<template>
  <div
    style="background-color: var(--color-bg); padding-top: 10px"
    v-if="!fetchLoading"
  >
    <ThemedSelector
      :items="profiles"
      :item-text="(profile) => profile.profileName"
      v-model="selectedProfileModel"
      auto-select-first
      no-data-text="No profiles found"
      return-object
      cache-items
      outlined
      append-icon="none"
      label="Select preset profile"
      persistent-placeholder
      :menu-props="{ bottom: true, offsetY: true }"
      :key="selectedProfile ? selectedProfile.profileName : null"
    />

    <ProfileDetails v-if="selectedProfile != null" />
    <NoProfileSelected v-else />
  </div>

  <PresetsLoadingView v-else />
</template>
<script>
import { mapState } from "vuex";
import PresetsLoadingView from "./LoadingView.vue";
import ProfileDetails from "./components/ProfileDetails.vue";
import NoProfileSelected from "./components/NoProfileSelected.vue";
import ThemedSelector from "../../../core/ThemedSelector.vue";
export default {
  name: "PresetCalculationView",
  components: {
    PresetsLoadingView,
    ProfileDetails,
    NoProfileSelected,
    ThemedSelector,
  },
  data() {
    return {};
  },
  computed: {
    ...mapState("kDiagram/profiles", [
      "profiles",
      "selectedProfile",
      "fetchLoading",
    ]),
    selectedProfileModel: {
      get() {
        return this.selectedProfile;
      },
      set(value) {
        this.$store.commit("kDiagram/profiles/SET_SELECTED_PROFILE", value);
        this.$store.commit(
          "kDiagram/SET_CALCULATION_DATA_ACCORDING_TO_PROFILE",
          value
        );
      },
    },
  },
  methods: {
    displayNumericValue(value, precision) {
      try {
        return value.toFixed(precision);
      } catch (error) {
        return "-";
      }
    },
  },
};
</script>



